import { Kankan4D } from './kankan4d';
import { PanoComponent } from './vrPano.lead';
/**
 *
 * @param { Object } initSettings 初始设置
 * @param { String } initSettings.xmlUrl   接口地址
 * @param { Number } initSettings.dealerId  经销商id
 * @param { Number } initSettings.cityId   城市id
 * @param { String } initSettings.source  来源
 */
export function createPanoComponent(initSettings) {
  console.log('initSettings:', initSettings);
  if (initSettings && initSettings.panoType === '4dKankan') {
    return new Kankan4D(initSettings);
  }
  return new PanoComponent(initSettings);
}
